import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'react-final-form';
import {Grid, TextInput} from '@tenancy.nz/design-system';
import {
  getFieldProps,
  composeValidators,
  isEmailAddress,
  isRequired,
} from '../utils/helpers';

function PersonalDetailFieldset({name, ...rest}) {
  const prefix = name ? `${name}.` : ``;
  return (
    <Grid container spacing={5} {...rest}>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}first_name`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="First Name"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}middle_name`}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              fullWidth
              label="Middle Name"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}last_name`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Last Name"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field
          name={`${prefix}email`}
          validate={composeValidators(isRequired, isEmailAddress)}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Email"
              type="email"
              helperText="If you do not have an email please call 0800 483 626 and ask to speak to a Privacy Officer"
              helperTextPlacement="below"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}phone`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Phone"
              type="tel"
              helperText="We will call you to discuss your request and only act on your request after we have spoken to you"
              helperTextPlacement="below"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}dob`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Date of Birth"
            />
          )}
        </Field>
      </Grid>
    </Grid>
  );
}

PersonalDetailFieldset.propTypes = {
  /**
   *
   */
  name: PropTypes.string,
};

PersonalDetailFieldset.defaultProps = {
  name: undefined,
};

export default PersonalDetailFieldset;
